//#region Register
import i18n from "../plugins/i18n";

export function getPD_ERROR() {
    return {
        fullName: { error: null, message: null, required: true, maxLength: 50 },
        phone: {
            error: null,
            message: null,
            text: "_REGISTER.PHONE_NUMBER_NOT_LESS_THAN",
            required: true,
            minLength: 8
        },
        email: { error: null, message: null, required: true, type: "email" },
        position: { error: null, message: null, required: true, maxLength: 50 }
    }
};
export const HD_ERROR = {
    hotelName: { error: null, message: null, required: true, maxLength: 255 },
    hotelPhone: {
        error: null,
        message: null,
        text: "_REGISTER.PHONE_NUMBER_NOT_LESS_THAN",
        required: true,
        minLength: 8
    },
    hotelEmail: {
        error: null,
        required: true,
        type: "email"
    },
    hotelTypeId: { error: null, required: true },
    hotelStar: { error: null, required: true },
    hotelNumberOfRooms: { error: null, required: true },
    hotelTaxCode: { error: null, required: true },
    hotelCountryId: { error: null, required: true },
    hotelCityId: { error: null, required: true },
    hotelLocId: { error: null, required: true },
    hotelAddress: { error: null, message: null, required: true, maxLength: 255 }
};
export const CA_ERROR = {
    username: { error: null, message: null, required: true },
    password: {
        error: null,
        message: null,
        text: "Mật khẩu nhập ít nhất 8 ký tự",
        required: true,
        minLength: 8
    },
    retypepassword: {
        error: null,
        message: null,
        text: "Xác nhận  mật khẩu nhập ít nhất 8 ký tự",
        required: true,
        minLength: 8
    }
};
// Account setting - info
export function getAsError() {
    return {
        fullName: { error: null, message: null, required: true, maxLength: 255 },
        email: { error: null, message: null, required: true, type: 'email' },
        phoneNumber: { error: null, message: null, required: true, minLength: 8, text: '_ACCOUNT_SETTING.ERROR_PHONE_NUMBER_MIN' },
        address: { error: null, message: null, required: false, maxLength: 255 },
        position: { error: null, message: null, required: false, maxLength: 255 }
    };
};
// Account setting - password
export function getAsPassError() {
    return {
        oldPassword: { error: null, message: null, required: true, },
        newPassword: { error: null, message: null, successMessage: null, required: true, minLength: 8, text: "_ACCOUNT_SETTING.ERROR_PASSWORD_MIN" },
        retypeNewPassword: { error: null, message: null, required: true, minLength: 8, text: "_ACCOUNT_SETTING.ERROR_RETYPE_PASSWORD_MIN" }
    };
};
// Account manage user
export function getMuError() {
    return {
        userName: { error: null, message: null, required: true, maxLength: 50 },
        fullName: { error: null, message: null, required: true, maxLength: 255 },
        email: { error: null, message: null, required: true, type: 'email' },
        phone: { error: null, message: null, required: true, minLength: 8, text: "_EDIT_USER.ERROR_PHONE_NUMBER_MIN" },
        address: { error: null, message: null, required: false, maxLength: 255 },
        position: { error: null, message: null, required: false, maxLength: 50 },
        userGroup: { error: null, message: null, required: false }
    };
};
// Account manage user group
export function getMgError() {
    return {
        groupName: { error: null, message: null, required: true, maxLength: 30 },
        groupCode: { error: null, message: null, required: true, maxLength: 30 },
        role: { error: null, message: null, required: true, maxLength: 50 },
        selectedUserGroup: { error: null, message: null, required: false },
        selectedType: { error: null, message: null, required: true },
        description: { error: null, message: null, required: false, maxLength: 300 }
    };
};
export function getCoError() {
    return {
        enterpriseName: { error: null, message: null, required: true, maxLength: 255 },
        taxCode: { error: null, required: true, maxLength: 20 },
        registeredAddress: { error: null, message: null, required: true, maxLength: 255 },
        bankAccountNumber: { error: null, required: true, minLength: 6, maxLength: 50 },
        bankAccountName: { error: null, required: true, maxLength: 255 },
        bankName: { error: null, required: true },
        bankBranch: { error: null, required: true, maxLength: 255 },
        representative: { error: null, required: true, maxLength: 255 },
        signer: { error: null, required: true, maxLength: 255 },
        position: { error: null, required: true, maxLength: 255 }
    };
};
//#endregion
// Booking detail
export function getBkDtError() {
    return {
        reason: { error: null, required: true }
    };
}
//#endregion
// Booking transaction detail
export function getBkTdError() {
    return {
        paymentType: { error: null, required: true },
        transCode: { error: null, required: false },
        transDate: { error: null, required: true },
        unpaid: { error: null, required: true },
        notes: { error: null, required: false, maxLength: 255 }
    };
}
//#endregion
// Travel agent
export function getTrAcError() {
    return {
        reason: { error: null, required: true, maxLength: 100 }
    };
}
//#endregion
// Hotel chain
export function getHotelChainNameError() {
    return {
        chainName: { error: null, message: null, required: true }
    };
}
export function getHotelChainError() {
    return {
        username: { error: null, message: null, required: true, maxLength: 50 },
        password: { error: null, message: null, required: true, minLength: 8, text: "_ACCOUNT_SETTING.ERROR_PASSWORD_MIN" }
    };
}
//#endregion

// General setting
export const DAYS_OF_WEEK = [
    { id: 1, text: i18n.t("DAYS_OF_WEEK.MON"), date: "MON" },
    { id: 2, text: i18n.t("DAYS_OF_WEEK.TUE"), date: "TUE" },
    { id: 3, text: i18n.t("DAYS_OF_WEEK.WED"), date: "WED" },
    { id: 4, text: i18n.t("DAYS_OF_WEEK.THU"), date: "THU" },
    { id: 5, text: i18n.t("DAYS_OF_WEEK.FRI"), date: "FRI" },
    { id: 6, text: i18n.t("DAYS_OF_WEEK.SAT"), date: "SAT" },
    { id: 7, text: i18n.t("DAYS_OF_WEEK.SUN"), date: "SUN" }
];
export const GE_LANGUAGE = [
    { vi: "Tiếng Việt", en: "Vietnamese", lang: "vi" },
    { vi: "Tiếng Anh", en: "English", lang: "en" }
];
export const GE_ROOM_SERVICES = [
    { value: 0, text: i18n.t("NO") },
    { value: 1, text: i18n.t("YES") }
];
export const ELECT_VOLT = [
    { id: 1, value: 100 },
    { id: 2, value: 110 },
    { id: 3, value: 220 }
];
export const CURRENCY = [{ id: 1, value: "VND" }, { id: 2, value: "USD" }, { id: 3, value: "INR" }]; //{ id: 3, value: "EUR" }
export const GE_ERROR = {
    email: { error: null, message: null, required: true, type: "email" },
    notifyToEmail: { error: null, message: null, required: false, type: "email" },
    // notifyCCEmail1: { error: null, message: null, required: false, type: "email" },
    // notifyBCCEmail: {
    //     error: null,
    //     message: null,
    //     required: false,
    //     type: "email"
    // },
    language: { error: null, message: null, required: true },
    weekend: { error: null, message: null, required: true },
    usedCurrency: { error: null, message: null, required: true },
    dataAddedTaxPercent: { error: null, message: null, required: true },
    serviceTaxPercent: { error: null, message: null, required: true },
    baged: { error: null, message: null, required: true },
    caged: { error: null, message: null, required: true },
    checkInTime: { error: null, message: null, required: true },
    checkOutTime: { error: null, message: null, required: true },
    yearOfBuild: { error: null, message: null },
    numberOfFloors: { error: null, message: null },
    numberOfRooms: { error: null, message: null },
    distanceToCenter: { error: null, message: null },
    distanceToAirport: { error: null, message: null },
    minutesToAirport: { error: null, message: null },
};
// End

// Payment policy
export const AP_ERROR = {
    startDate: { error: null, message: null, required: null },
    endDate: { error: null, message: null, required: null },
    paymentDay: { error: null, message: null, required: true },
    cutOfDate: { error: null, message: null, required: true },
    amount: { error: null, message: null, required: true }
};
// End

// Cancellation
export const AC_ERROR = {
    startDate: { error: null, message: null, required: null },
    endDate: { error: null, message: null, required: null },
    cancellationDay: { error: null, message: null, required: true },
    amount: { error: null, message: null, required: true }
};
// End

// Pay gate
export const PG_ERROR = [
    { id: 1, error: null },
    { id: 2, error: null },
    { id: 3, error: null },
];
export const ONLINE_PAY_GATE = {
    onePayInland: { id: 1, isChecked: null },
    onePayInternational: { id: 2, isChecked: null },
    vnPay: { id: 3, isChecked: null }
};

// Paygate setting
export const PG_SETTING_ERROR = {
    AgainLink: { error: null, required: true },
    AVS_PostCode: { error: null, required: true },
    vpc_AccessCode: { error: null, required: true },
    vpc_Command: { error: null, required: true },
    Title: { error: null, required: true },
    vpc_Version: { error: null, required: true },
    vpc_Merchant: { error: null, required: true },
    vpc_Secrey: { error: null, required: true },
    vpc_Url: { error: null, required: true }
};

// General infomation
export const RI_ERROR = {
    telephone: {
        error: null,
        message: null,
        text: "_REGISTER.PHONE_NUMBER_NOT_LESS_THAN",
        required: true,
        minLength: 8
    },
    lat: { error: null, required: true },
    lng: { error: null, required: true },
    zoom: { error: null, required: true },
    countryId: { error: null, required: true },
    cityId: { error: null, required: true },
    locId: { error: null, required: true },
    nameVi: { error: null, required: true },
    nameEn: { error: null, required: true },
    addressVi: { error: null, required: true },
    addressEn: { error: null, required: true },
    timeZoneStr: { error: null, required: true },
};

//#region Room information
export const MAX_CHILD_QUANTITY = 11;
export const MAX_ADULTS_QUANTITY = 30;
export const EXTRA_BED_QUANTITY = 11;
export const BED_QUANTITY = 100;
export const ROOM_INFO_ERROR = {
    nameVi: { error: null, required: true },
    nameEn: { error: null, required: true },
    totalRooms: { error: null, required: true },
    defaultPrice: { error: null, required: true },
    weekendRate: { error: null, required: true },
    roomSize: { error: null, required: true }
};
//#endregion
// Sale room
export const MEALS = [ //không sử dụng ở đâu
    { id: 1, text: i18n.t("_PROMOTION.MEALS.BREAKFAST") },
    { id: 2, text: i18n.t("_PROMOTION.MEALS.LUNCH") },
    { id: 3, text: i18n.t("_PROMOTION.MEALS.DINNER") }
];

export const PROMOTION_TYPE_LIST = [
    { id: 1, text: i18n.t("_PROMOTION.PROMOTION_TYPE_LIST.EVERY_NIGHT") },
    { id: 2, text: i18n.t("_PROMOTION.PROMOTION_TYPE_LIST.TOTAL_BOOKING") },
    { id: 4, text: i18n.t("_PROMOTION.PROMOTION_TYPE_LIST.ORDER_BEFORE") },
    { id: 5, text: i18n.t("_PROMOTION.PROMOTION_TYPE_LIST.ORDER_WITHIN") },
    { id: 6, text: i18n.t("_PROMOTION.PROMOTION_TYPE_LIST.FREE_QUANTITY") },
    { id: 7, text: i18n.t("_PROMOTION.PROMOTION_TYPE_LIST.FREE_ON_TOTAL_VALUE") }
];
export const DISCOUNT_LIST = [
    { id: 0, text: i18n.t("_PROMOTION.DISCOUNT_LIST.DISCOUNT") },
    { id: 1, text: i18n.t("_PROMOTION.DISCOUNT_LIST.SURCHARGE") }
];

export const TARGET_APPLY_LIST = [
    { id: 0, text: i18n.t("_PROMOTION.TARGET_APPLY_LIST.BY_AGENT_LEVEL") },
    { id: 1, text: i18n.t("_PROMOTION.TARGET_APPLY_LIST.BY_AGENT") }
];
export const LEVEL_TARGET_APPLY = [
    { id: 1, text: i18n.t("_PROMOTION.LEVEL_TARGET_APPLY.LEVEL_1") },
    { id: 2, text: i18n.t("_PROMOTION.LEVEL_TARGET_APPLY.LEVEL_2") },
    { id: 3, text: i18n.t("_PROMOTION.LEVEL_TARGET_APPLY.LEVEL_3") },
    { id: 4, text: i18n.t("_PROMOTION.LEVEL_TARGET_APPLY.LEVEL_4") },
    { id: 5, text: i18n.t("_PROMOTION.LEVEL_TARGET_APPLY.LEVEL_5") }
];
export const SPD_ERROR = {
    nameVi: { error: null, required: true },
    nameEn: { error: null, required: true },
    minStay: { error: null, required: true, message: null },
    maxStay: { error: null, required: true, message: null },
    extraBedPrice: { error: null, required: null, message: null },
    exAdult: { error: null, required: null, message: null },
    exChild: { error: null, required: null, message: null },
    roomType: { error: null, required: null, message: null },
    meal: { error: null, required: null, message: null },
    roomsApply: { error: null },
    start: { error: null, required: null },
    end: { error: null, required: null }
};
export const PRO_PACK_ERROR = {
    nameVi: { error: null, required: true },
    nameEn: { error: null, required: true },
    promotionType: { error: null, required: true },
    amount: { error: null, required: true },
    percent: { error: null, required: true },
    applyLevels: { error: null, required: true },
    applyAgents: { error: null, required: true },
    coupon: { error: null, required: null },
    xdays: { error: null, required: null },
    yorder: { error: null, required: null },
    xorder: { error: null, required: null },
    startStayingDate: { error: null, required: null },
    endStayingDate: { error: null, required: null },
    startBookingDate: { error: null, required: null },
    endBookingDate: { error: null, required: null }
};

export const LIMIT_AND_OFFSET = {
    limit: 20,
    offset: 0
};

//#region amenitiy icons
export const AMENITIY_ICONS = [
    { id: 15, class: "icon-Kids-club_ic" },
    { id: 18, class: "icon-hour-front-desk_ic" },
    { id: 45, class: "icon-Golf-course-within-2-miles_ic" },
    { id: 61, class: "icon-Kids-meals_ic" },
    { id: 92, class: "icon-Kids-pool_ic" },
    { id: 134, class: "icon-Kids-TV-channels_ic" },
    { id: 158, class: "icon-hour-security_ic" }
];
//#endregion